const mutations = {
    SET_USER_DATA(state, params) {
        state.user = params;
    },
};

export default mutations;